<home-slider [slides]="mainCardDataList"></home-slider>
<about-home></about-home>
<app-features [features]="features" gridTemplateColumns="repeat(3, 1fr)" title="What Makes Us Different?"
/>
<solutions-section />
<technology-section image="assets/images/tec.png">
